import React from 'react'
import PropTypes from 'prop-types'

class AddressInfo extends React.Component {
  render() {
    const { info, allCountries } = this.props
    const {
      first_name: firstName,
      last_name: lastName,
      phone,
      address_hash: address,
    } = info

    let {
      street_address: streetAddress,
      city, postcode,
      poboxnumber: postBox,
      district, landmark, state,
    } = address
    const {
      country: currentCountryCode,
    } = address

    streetAddress = streetAddress || ''
    city = city || ''
    postcode = postcode || ''
    district = district || ''
    landmark = landmark || ''
    postBox = postBox || ''
    state = state || ''

    let country = allCountries.find((c) => c.code === currentCountryCode)
    country = country || ''

    return (
      <>
        <div className='address-info '>
          <div className='address-row'>
            <p className='title'>Name</p>
            <p className='content'>{ `${firstName}  ${lastName}`}</p>
          </div>
          <div className='address-row'>
            <p className='title'>Address</p>
            <p className='content'>{ `${streetAddress}  ${city} ${district}  ${landmark} ${state} ${postcode} ${postBox} ${country.name}`}</p>
          </div>
          <div className='address-row'>
            <p className='title'>Phone Number</p>
            <p className='content'>{ `${phone}`}</p>
          </div>
        </div>
      </>
    )
  }
}

AddressInfo.propTypes = {
  info: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    phone: PropTypes.number,
    address_hash: PropTypes.shape({}),
  }).isRequired,
  allCountries: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
    phone_code: PropTypes.string,
  })).isRequired,
}

export default AddressInfo
